"use client";

import { Compass, TreePalm, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseUsSection() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="why-choose-us-section" ref={sectionRef} className="relative min-h-screen bg-background text-foreground py-24 px-6 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-[10%] w-80 h-80 rounded-[60%_40%_30%_70%/60%_30%_70%_40%] bg-accent/20 blur-3xl animate-[float_8s_ease-in-out_infinite]" style={{
        animationDelay: "0s"
      }} />
        <div className="absolute bottom-32 right-[15%] w-96 h-96 rounded-[40%_60%_70%_30%/50%_60%_40%_50%] bg-secondary/15 blur-3xl animate-[float_10s_ease-in-out_infinite]" style={{
        animationDelay: "2s"
      }} />
        <div className="absolute top-1/2 left-1/3 w-72 h-72 rounded-[50%_50%_30%_70%/30%_70%_70%_30%] bg-primary/10 blur-3xl animate-[float_12s_ease-in-out_infinite]" style={{
        animationDelay: "4s"
      }} />
      </div>

      {}
      <div className="relative z-10 max-w-6xl mx-auto">
        {}
        <div className={`text-center mb-20 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-display text-5xl md:text-6xl font-bold mb-6 tracking-tight">
            Why Choose Us
          </h2>
          <p className="text-muted text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Discover the exclusive blend of adventure, culture, and Caribbean elegance that sets EcoLuxMaya apart.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {}
          <div data-index={0} className={`flex flex-col items-center text-center space-y-6 transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-32 h-32 flex items-center justify-center">
              <div className="absolute inset-0 rounded-[60%_40%_30%_70%/60%_30%_70%_40%] bg-primary/20 blur-xl animate-[float_6s_ease-in-out_infinite]" />
              <div className="relative z-10 w-20 h-20 rounded-[50%_50%_40%_60%/40%_60%_60%_40%] bg-primary/30 flex items-center justify-center animate-[float_5s_ease-in-out_infinite] shadow-soft">
                <Compass className="w-10 h-10 text-primary" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="font-display text-2xl font-semibold">Adventure</h3>
            <p className="text-muted leading-relaxed max-w-xs">
              Embark on thrilling jungle safaris, cenote explorations, and yacht charters that immerse you in nature's wonders.
            </p>
          </div>

          {}
          <div data-index={1} className={`flex flex-col items-center text-center space-y-6 transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-32 h-32 flex items-center justify-center">
              <div className="absolute inset-0 rounded-[40%_60%_70%_30%/50%_60%_40%_50%] bg-accent/20 blur-xl animate-[float_7s_ease-in-out_infinite]" />
              <div className="relative z-10 w-20 h-20 rounded-[40%_60%_50%_50%/60%_40%_50%_50%] bg-accent/30 flex items-center justify-center animate-[float_6s_ease-in-out_infinite] shadow-soft">
                <TreePalm className="w-10 h-10 text-accent" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="font-display text-2xl font-semibold">Culture</h3>
            <p className="text-muted leading-relaxed max-w-xs">
              Experience authentic heritage tours guided by local experts who bring the Riviera Maya's rich history to life.
            </p>
          </div>

          {}
          <div data-index={2} className={`flex flex-col items-center text-center space-y-6 transition-all duration-700 delay-[300ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-32 h-32 flex items-center justify-center">
              <div className="absolute inset-0 rounded-[50%_50%_30%_70%/30%_70%_70%_30%] bg-secondary/20 blur-xl animate-[float_8s_ease-in-out_infinite]" />
              <div className="relative z-10 w-20 h-20 rounded-[60%_40%_60%_40%/50%_50%_50%_50%] bg-secondary/30 flex items-center justify-center animate-[float_7s_ease-in-out_infinite] shadow-soft">
                <Sparkles className="w-10 h-10 text-secondary" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="font-display text-2xl font-semibold">Elegance</h3>
            <p className="text-muted leading-relaxed max-w-xs">
              Indulge in luxury eco-resorts and sunset cruises designed for discerning travelers seeking refined experiences.
            </p>
          </div>
        </div>
      </div>

      {}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
          }
          25% {
            transform: translateY(-20px) translateX(10px);
          }
          50% {
            transform: translateY(-10px) translateX(-10px);
          }
          75% {
            transform: translateY(-30px) translateX(5px);
          }
        }
      `}</style>
    </section>;
}